import { render, staticRenderFns } from "./singleTest.vue?vue&type=template&id=e4bb8c88&scoped=true&"
import script from "./singleTest.vue?vue&type=script&lang=js&"
export * from "./singleTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bb8c88",
  null
  
)

export default component.exports